<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQCinema',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Cinema", link : 'conv-bitq-cinema' } ],

        // Nome welfarebit del servizio
        service_title : "Cinema",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 152
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>